import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import IconButton from '@mui/material/IconButton';
import MicIcon from '@mui/icons-material/Mic';
import ChatIcon from '@mui/icons-material/Chat';
import DracoUX from './DracoUX';
import '../../assets/css/DracoUX.css';
import '../../assets/css/DracoUXContainer.css';


const DracoUXContainer = forwardRef((props, ref) => {
    
    const [isListening, setIsListening] = useState(false);
    
    // DracoUX ref 객체
    const dracoUxRef = useRef();    

    // 채팅창 열기
    const onDrocoUx = (e) => {        
        dracoUxRef.current.handleOpen();   
    }

    const startSTT = () => {
        setIsListening(true);
        dracoUxRef.current.startSTT(true);
    }

    const stopSTT = () => {
        setIsListening(false);
        dracoUxRef.current.stopSTT();
    }

    const reciveCommand = (command) => {   
        if (command){
            props.reciveCommand(command);
        }             
    }

    // 부모 컴포넌트에서 호출 할 수 있는 함수 정의
    useImperativeHandle(ref, () => ({
        
    }))
    
    return (
        <div className="sider-button-container inc_dashboard_style_setting">

            <IconButton className={isListening  ? "listening sb_view_style" : "sb_view_style"}
                        size="large"
                        aria-label="mic"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        color="inherit"                        
                        sx={{ borderRadius:"30px", border:"3px solid rgb(215, 151, 126);", color:"rgb(215, 151, 126);", marginRight:"10px", backgroundColor: 'white'}}
                        onMouseDown={startSTT}
                        onMouseUp={stopSTT}
                        onTouchStart={startSTT}
                        onTouchEnd={stopSTT}>
                <MicIcon/>
            </IconButton> 

            <IconButton size="large"
                        className="sb_view_style"
                        aria-label="chat"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        color="inherit"
                        onClick={onDrocoUx}
                        sx={{ borderRadius:"30px", border:"3px solid rgb(211, 150, 126);", color:"rgb(215, 151, 126);", backgroundColor: 'white'}}>
                <ChatIcon/>
            </IconButton>  

            <DracoUX ref={dracoUxRef} reciveCommand={reciveCommand}/>
        </div>       
    )
});

export default DracoUXContainer